{
  "title": "Chats",
  "description": "Class, project and direct conversations.",
  "loading": "Loading…",
  "empty": {
    "title": "No conversations yet",
    "text": "Start a direct message with anyone you are allowed to write to."
  },
  "emptySearch": "No conversations match that.",
  "selectThread": "Pick a conversation to start reading.",
  "backToList": "Back to conversations",
  "threadList": "Conversations",
  "sections": {
    "class": "Classes",
    "project": "Projects",
    "direct": "Direct messages"
  },
  "noMessages": "No messages yet. Say hello.",
  "noPreview": "No messages yet",
  "unread_one": "{{count}} unread",
  "unread_other": "{{count}} unread",
  "muted": "Muted",
  "mute": "Mute this conversation",
  "unmute": "Unmute this conversation",
  "muteSaved": "Notification preference saved.",
  "participants_one": "{{count}} participant",
  "participants_other": "{{count}} participants",
  "realtime": {
    "reconnecting": "Reconnecting…",
    "live": "Live"
  },
  "composer": {
    "label": "Message",
    "placeholder": "Write a message…",
    "send": "Send",
    "sending": "Sending…",
    "hint": "Enter to send, Shift+Enter for a new line.",
    "mutedByStaff": "You have been muted in this conversation and can read it but not post."
  },
  "message": {
    "removed": "Message removed",
    "actions": "Message actions",
    "delete": "Delete message",
    "deleteConfirmTitle": "Delete this message?",
    "deleteConfirmBody": "It stays in place as “Message removed”. This cannot be undone.",
    "deleted": "Message deleted.",
    "report": "Report message",
    "you": "You"
  },
  "report": {
    "title": "Report this message",
    "description": "A school admin reviews every report. Tell them what is wrong.",
    "quoted": "Reported message",
    "reason": "Reason",
    "reasons": {
      "abuse": "Bullying or abuse",
      "inappropriate": "Inappropriate content",
      "spam": "Spam",
      "other": "Other"
    },
    "details": "Anything else the admin should know (optional)",
    "detailsPlaceholder": "Add context…",
    "submit": "Send report",
    "sent": "Report sent. An admin will review it."
  },
  "newDm": {
    "button": "New message",
    "title": "Start a direct message",
    "description": "Pick who you want to write to.",
    "search": "Search people",
    "searchPlaceholder": "Search by name…",
    "empty": "Nobody to show here.",
    "pupilsOff": "This school does not allow pupils to message each other privately.",
    "start": "Start conversation",
    "starting": "Starting…"
  },
  "cancel": "Cancel",
  "roles": {
    "admin": "Admin",
    "teacher": "Teacher",
    "pupil": "Pupil",
    "parent": "Parent"
  },
  "unreadCard": {
    "title": "Unread messages",
    "empty": "You are all caught up.",
    "total_one": "{{count}} unread message",
    "total_other": "{{count}} unread messages",
    "open": "Open chats"
  },
  "loadOlder": "Load older messages"
}
